import BrowserDetect from './BrowserDetect';

const FOCUSABLE_INPUT_TYPES = [
    'tel',
    'text',
    'email',
    'number',
    'password',
    'search',
    'url',
];

/**
 * Focus an input during the same iOS touch gesture so the keyboard opens.
 * Attach to a container wrapping StepUp content (Modal or full page).
 */
export function handleIOSModalInputTouchStart(event) {
    if (!BrowserDetect.isIOS()) {
        return;
    }

    const target = event.target;
    if (!target || target.tagName !== 'INPUT') {
        return;
    }

    if (FOCUSABLE_INPUT_TYPES.indexOf(target.type) === -1) {
        return;
    }

    if (document.activeElement !== target) {
        target.focus();
    }
}
